import { createContext, useReducer, useContext } from "@wordpress/element";
import {
    toastReducer,
    toastInitialState,
} from "../components/Toast/toastReducer";

export const ToastContext = createContext({
    toasts: [],
    addToast: () => {},
    removeToast: () => {},
    clearAllToasts: () => {},
});

export function ToastProvider({ children }) {
    const [toastState, toastDispatch] = useReducer(
        toastReducer,
        toastInitialState
    );

    // Add toast
    const addToast = (toast) => {
        const id = Date.now() + Math.random();
        const newToast = {
            id,
            type: "info",
            duration: 3000,
            ...toast,
        };

        toastDispatch({
            type: "ADD_TOAST",
            payload: newToast,
        });

        // Auto remove toast after duration
        if (newToast.duration > 0) {
            setTimeout(() => {
                removeToast(id);
            }, newToast.duration);
        }

        return id;
    };

    // Remove toast
    const removeToast = (id) => {
        toastDispatch({
            type: "REMOVE_TOAST",
            payload: id,
        });
    };

    // Clear all toasts
    const clearAllToasts = () => {
        toastDispatch({
            type: "CLEAR_ALL_TOASTS",
        });
    };

    return (
        <ToastContext.Provider
            value={{
                toasts: toastState.toasts,
                addToast,
                removeToast,
                clearAllToasts,
            }}
        >
            {children}
        </ToastContext.Provider>
    );
}
